
import { Component, Vue } from "vue-property-decorator";
import { TTask_Table } from "@/models/tasks_services";
import { SMCases, SMTasksServices, SMUser, SMApp } from "@/store";
import WidgetTemplate from "@/components/Widgets/Templates/WidgetTemplate.vue";
import ImageSponsorLicence from "@/assets/images/candidate/hello-img-sponsor-licence.png";
import ImageSkilledWorker from "@/assets/images/candidate/hello-img-skilled-worker.png";
import {
  SKILLED_WORKER_SERVICE_TYPE,
  SKILLED_WORKER_INSIDE_SERVICE_TYPE,
} from "@/constants/services";

const ICONS = {
  plus: "add-outline",
};

const TASKS_PATH = "/cases/tasks/";

@Component({
  components: {
    WidgetTemplate,
  },
})
export default class Hello extends Vue {
  messages = {
    title: "Hello!",
    button: {
      startTask: "Start the next task",
      getDependentVisa: "Start dependant visa",
    },
    instructions: {
      skilled_worker: [
        `Complete all <b>Your tasks</b> to move to the next step.`,
        `You can edit your data on <b>Personal details</b> and <b>Employment</b> tabs.`,
        `Submit <b>Final Application</b> for expert review.`,
      ],
      sponsor_licence: [
        `Complete all <b>Your tasks</b> to move to the next step.`,
        `You can edit provided data on <b>Company profile</b>, <b>Case profile</b>, and <b>${this.detailsTabName}</b> tabs.`,
        `Submit <b>Final Application</b> for expert review.`,
      ],
    },
  };

  get isSWType() {
    return [SKILLED_WORKER_SERVICE_TYPE, SKILLED_WORKER_INSIDE_SERVICE_TYPE].includes(
      SMCases.caseType
    );
  }

  get detailsTabName() {
    return SMApp.hasSlCandidatesTab ? "Candidates" : "Job details";
  }

  get instructions() {
    return this.isSWType
      ? this.messages.instructions.skilled_worker
      : this.messages.instructions.sponsor_licence;
  }

  get image() {
    return this.isSWType ? ImageSkilledWorker : ImageSponsorLicence;
  }

  get caseId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get tasks() {
    if (SMUser.isEmployer) return SMTasksServices.employerTasksToDo;

    return SMTasksServices.candidateTasksToDo;
  }

  openFirstToDoTask() {
    if (!this.tasks.length) return;

    const task: TTask_Table = this.tasks[0];

    const { id } = task;

    if (!id) return;

    this.$router.push(`${TASKS_PATH}${id}`);
  }

  get getDependantVisaEnable() {
    const service = (SMCases.case as unknown) as { can_start_dependant_case: boolean };

    return service.can_start_dependant_case;
  }

  get dependentVisaButtonProps() {
    return {
      iconLeft: ICONS.plus,
    };
  }

  getDependentVisa() {
    this.$root.$emit("get-dependant-visa", {
      serviceId: SMCases.caseId,
    });
  }
}
